export function createMatcherFunction(
  matchMap: {[key: string]: any},
  defaultValue: any = null
) {
  return (key: string | number) =>
    matchMap[key] ? matchMap[key] : defaultValue
}
